// AuthProvider.js

import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    return storedAuth ? JSON.parse(storedAuth) : false;
  });
  const [userRole, setUserRole] = useState(() => {
    const storedRole = localStorage.getItem('userRole');
    return storedRole || '';
  });
  const navigate = useNavigate();

  useEffect(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    if (storedAuth) {
      setIsAuthenticated(JSON.parse(storedAuth));
    }
    const storedRole = localStorage.getItem('userRole');
    if (storedRole) {
      setUserRole(storedRole);
    }
  }, []);

  const login = (userData) => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', true);
    localStorage.setItem('userRole', userData.role);
    if (userData.status === 'ACTIVE' && userData.role === 'STUDENT') {
      navigate('/student-dashboard');

    }
    else if (userData.status === 'REGISTRATION' || userData.status === 'INACTIVE' && userData.role === 'STUDENT') {
      navigate('/student-registration-dashboard');

    }

    else if (userData.status === 'ACTIVE' && userData.role === 'INSTRUCTOR') {
      navigate('/instructor-dashboard');

    }
    else if (userData.status === 'ACTIVE' && userData.role === 'HOST') {
      navigate('/host-dashboard');

    }
    else {
      navigate('/dashboard');


    }
    // navigate('/dashboard');
  };

  const logout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userData');
    localStorage.removeItem('suzaToken');
    setIsAuthenticated(false);
    setUserRole('');
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, userRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
